import { render, staticRenderFns } from "./techTalent.vue?vue&type=template&id=d0968d3a&scoped=true"
import script from "./techTalent.vue?vue&type=script&lang=js"
export * from "./techTalent.vue?vue&type=script&lang=js"
import style0 from "./techTalent.vue?vue&type=style&index=0&id=d0968d3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0968d3a",
  null
  
)

export default component.exports